import { ChangeDetectionStrategy, Component, HostListener, inject } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

import { CONFIRM_RESULT, ConfirmOptions } from "../../model";
import { CloseButtonComponent } from "../close-button";

@Component({
  selector: "rms-confirmation-dialog",
  imports: [MatIconModule, TranslateModule, CloseButtonComponent, MatButton],
  template: `
    <div class="flex flex-col gap-3">
      <header class="rms-dialog-header">
        <h1 class="font-bold text-2xl">
          {{ data.title.text | translate: data.title.payload }}
        </h1>

        <rms-close-button (click)="dismiss()" />
      </header>

      <h3
        class="text-lg"
        [innerHTML]="data.message.text | translate: data.message.payload"
      ></h3>

      <div class="rms-dialog-actions">
        <button
          class="rms-dialog-actions-button"
          (click)="cancel()"
          mat-stroked-button
        >
          {{ "libs.common.cancel" | translate }}
        </button>

        <button
          class="rms-dialog-actions-button"
          (click)="ok()"
          color="primary"
          mat-raised-button
        >
          {{ "libs.common.ok" | translate }}
        </button>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationDialogComponent {
  protected readonly data = inject<ConfirmOptions>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(
    MatDialogRef<ConfirmationDialogComponent, CONFIRM_RESULT>,
  );

  @HostListener('document:keydown.enter', ['$event'])
  public onEnter(event: KeyboardEvent): void {
    event.preventDefault();
    this.ok();
  }

  public ok(): void {
    this.dialogRef.close(CONFIRM_RESULT.OK);
  }

  public cancel(): void {
    this.dialogRef.close(CONFIRM_RESULT.CANCEL);
  }

  public dismiss(): void {
    this.dialogRef.close(CONFIRM_RESULT.DISMISS);
  }
}
